import { allWithPrefix, getDefaultPrefix, withPrefix } from "../withPrefix";
import { toKebabCase } from "../strings";
const toKebab = (s) => s == null ? '' : s.split('_').join('-').toLocaleLowerCase();
export function createClassNameValue(rootClassName, name) {
    const DD = '--', __ = '__';
    const prefix = toKebab(rootClassName);
    const postfix = name == null ? '' : name.split(__ + __).map(p1 => p1.split(__).map(toKebab).join(__)).join(DD);
    const divider = name == null || rootClassName == null ? '' : postfix.startsWith(DD) || (postfix[0] === '-' && postfix[1] !== '-') ? '' : __;
    return prefix + divider + postfix;
}
// should do same as scripts/create-names-scss.js
export function createNames(id, componentName, ...keys) {
    return createHierarchicalNames(createRootId(id, componentName), componentName, ...keys);
}
function createRootId(id, componentName) {
    if (isUiTest() || isUnitTest() || id == null) {
        return toKebab(componentName);
    }
    return id + '-sd';
}
// should do same as scripts/create-names-scss.js
export function createHierarchicalNames(componentId = 'noid', componentName, ...keys) {
    const ROOT = 'ROOT';
    const namesKeysAsObjectWithoutROOT = {};
    const namesKeysAsObjectWithoutROOTKeyForIds = {};
    const namesKeysAsObjectWithoutROOTKeyForClassNames = {};
    const rootId = componentId !== null && componentId !== void 0 ? componentId : toKebab(componentName);
    const rootClassNameNoPrefix = createNameWithoutPrefix(componentName);
    const rootClassName = createName(componentName);
    const defaultPrefix = getDefaultPrefix();
    keys
        .map(key => key.toUpperCase())
        .filter(key => key !== ROOT)
        .forEach(key => {
        namesKeysAsObjectWithoutROOT[key] = key;
        namesKeysAsObjectWithoutROOTKeyForIds[key] = ('-' + toKebabCase(key)).replace(/----/g, '-').replace(/---/g, '-').replace(/--/g, '-');
        namesKeysAsObjectWithoutROOTKeyForClassNames[key] = key;
    });
    let classNames = {};
    Object.keys(namesKeysAsObjectWithoutROOTKeyForClassNames).forEach(key => {
        classNames[key] = createClassNameValue(rootClassNameNoPrefix, namesKeysAsObjectWithoutROOTKeyForClassNames[key]);
    });
    const r = {
        ID: allWithPrefix(rootId, namesKeysAsObjectWithoutROOTKeyForIds),
        CLASS: allWithPrefix(defaultPrefix, classNames),
    };
    r.ID[ROOT] = rootId;
    r.CLASS[ROOT] = rootClassName;
    return r;
}
export function createName(...substrings) {
    const defaultPrefix = getDefaultPrefix();
    return withPrefix(defaultPrefix, createNameWithoutPrefix(...substrings));
}
export function createNameWithoutPrefix(...substrings) {
    return toKebabCase(substrings.join('-')).replace(' ', '');
}
function isUnitTest() {
    return process.env.NODE_ENV === 'test';
}
function isUiTest() {
    //commented out because of security bug in CMA. LJO investigates
    /*if (__isTest == null) {
        __isTest = window.parent.document.querySelectorAll('link[href^="/__cypress"]').length > 0;
        //__isTest = true; // remove when ready to use hierarchical ids
    }
    return __isTest;*/
    return true;
}
//# sourceMappingURL=createNames.js.map
